(function () {
    'use strict';

    function calcHeight($timeout, $rootScope) {
        return {
            restrict: 'A',
            scope: {
                name: '@',
                selector: '@'
            },
            link: function (scope, element, attrs) {
                function convertPxToInt(val) {
                    if (!val) {
                        return 0;
                    }
                    return parseInt(val.replace('px', ''), 10);
                }

                function setElementHeight() {
                    $timeout(function () {
                        var foundElement = $(element[0]);
                        var childHeightElement = $(element[0]).find(scope.selector)
                            .not('.ng-hide');
                        console.log(foundElement.height());
                        foundElement.css('maxHeight', childHeightElement.height() +
                        convertPxToInt(foundElement.css('padding-top')) +
                        convertPxToInt(foundElement.css('padding-bottom')) +
                        convertPxToInt(childHeightElement.css('padding-top')) +
                        convertPxToInt(childHeightElement.css('padding-bottom')) +
                        "px");
                    }, 0);
                }

                setElementHeight(element);

                $rootScope.$on('elementHeightChanged', function (event, args) {
                    if (scope.name === args.elementName) {
                        setElementHeight();
                    }
                });
            }
        };
    }

    calcHeight.$inject = ['$timeout', '$rootScope'];

    angular.module('ecap.common').directive('calcHeight', calcHeight);
})();